import type { InputHTMLAttributes } from 'react'

interface TextFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  id: string
  label: string
}

export function TextField({ id, label, className = '', ...props }: TextFieldProps) {
  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium text-slate-700">
        {label}
      </label>
      <input
        id={id}
        className={`mt-1 block w-full rounded-lg border border-slate-300 px-3 py-2 shadow-sm focus:border-primary focus:ring-primary ${className}`}
        {...props}
      />
    </div>
  )
}
